'use strict';

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.object.values");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.options = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactCssThemr = require('react-css-themr');

var _icon = require('lemon-db/dist/options/icon.json');

var _icon2 = _interopRequireDefault(_icon);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _iconList = require('./iconList');

var _iconList2 = _interopRequireDefault(_iconList);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var options = exports.options = Object.assign({}, _icon2['default'], {
  icon: _iconList2['default']
});

var factory = function factory(_ref) {
  var identifier = _ref.identifier,
      UIIcon = _ref.UIIcon;

  var Icon = function (_React$Component) {
    _inherits(Icon, _React$Component);

    function Icon() {
      _classCallCheck(this, Icon);

      return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
    }

    _createClass(Icon, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            icon = _props.icon,
            color = _props.color,
            size = _props.size,
            align = _props.align,
            inline = _props.inline,
            theme = _props.theme;
        var style = {};

        if (color) {
          style.color = color;
        }

        var className = (0, _classnames2['default'])(theme.iconWrapper, theme[align], theme[inline]);
        return _react2['default'].createElement('span', {
          className: className
        }, _react2['default'].createElement(UIIcon, {
          style: style,
          size: size,
          theme: theme,
          icon: icon,
          color: 'none'
        }));
      }
    }]);

    return Icon;
  }(_react2['default'].Component);

  Icon.displayName = identifier;
  Icon.themeShape = _extends({}, UIIcon.themeShape, {
    iconWrapper: _propTypes2['default'].string.isRequired
  });
  Icon.propTypes = {
    icon: _propTypes2['default'].oneOf(options.icon).isRequired,
    color: _propTypes2['default'].string,
    inline: _propTypes2['default'].bool,
    align: _propTypes2['default'].oneOf(Object.values(options.align)),
    size: UIIcon.propTypes.size,
    theme: _propTypes2['default'].shape(Icon.themeShape)
  };
  Icon.defaultProps = {
    icon: 'face',
    size: options.sizes.icon
  };
  return Icon;
};

exports['default'] = factory;